// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m2RJp","col":"styles_col__2fdOx"};